module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-02-b2e1d43b33b922a0ca5e7ad4b97000bf.jpg";